const accordion = require("./accordion");
const banner = require("./banner");
const characterCount = require("./character-count");
const comboBox = require("./combo-box");
const footer = require("./footer");
const navigation = require("./navigation");
const password = require("./password");
const search = require("./search");
const skipnav = require("./skipnav");
const validator = require("./validator");

module.exports = {
  accordion,
  banner,
  characterCount,
  comboBox,
  footer,
  navigation,
  password,
  search,
  skipnav,
  validator
};
